import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "search-section" }
const _hoisted_2 = { class: "form-box" }
const _hoisted_3 = { class: "form-content" }
const _hoisted_4 = { class: "inputbox" }
const _hoisted_5 = { class: "inputbox" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { type: "submit" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "results" }
const _hoisted_10 = { class: "table-content" }
const _hoisted_11 = { class: "icon" }
const _hoisted_12 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderDots = _resolveComponent("LoaderDots")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)), ["prevent"])),
        autocomplete: "off"
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("h2", null, "Order Details", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "orderid",
              placeholder: "Order Id",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchCriteria.orderId) = $event))
            }, null, 512), [
              [_vModelText, _ctx.searchCriteria.orderId]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "userid",
              placeholder: "User Id",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchCriteria.userId) = $event))
            }, null, 512), [
              [_vModelText, _ctx.searchCriteria.userId]
            ])
          ]),
          _createElementVNode("div", {
            disabled: _ctx.isSubmitting,
            class: "button-container"
          }, [
            _createElementVNode("button", _hoisted_7, [
              (!_ctx.isSubmitting)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Search"))
                : _createCommentVNode("", true),
              (_ctx.isSubmitting)
                ? (_openBlock(), _createBlock(_component_LoaderDots, { key: 1 }))
                : _createCommentVNode("", true)
            ])
          ], 8, _hoisted_6)
        ])
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "result-title" }, "Search Results", -1)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("table", null, [
          _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
            _createElementVNode("tr", { class: "table-header" }, [
              _createElementVNode("th", null, "Order Date"),
              _createElementVNode("th", null, "Order ID"),
              _createElementVNode("th", null, "User ID"),
              _createElementVNode("th", null, "Email Address"),
              _createElementVNode("th", null, "Order Total"),
              _createElementVNode("th", null, "Actions")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderDetails, (order) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "table-row",
                key: order.userId
              }, [
                _createElementVNode("td", null, _toDisplayString(order.formattedCreateDate), 1),
                _createElementVNode("td", null, _toDisplayString(order.orderId), 1),
                _createElementVNode("td", null, _toDisplayString(order.userId), 1),
                _createElementVNode("td", null, _toDisplayString(order.emailAddress), 1),
                _createElementVNode("td", null, _toDisplayString(order.formattedTotalAmount), 1),
                _createElementVNode("td", _hoisted_11, [
                  _createElementVNode("a", {
                    href: `/orders/${order.orderId}`
                  }, _cache[4] || (_cache[4] = [
                    _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 512 512"
                    }, [
                      _createElementVNode("path", { d: "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z" })
                    ], -1)
                  ]), 8, _hoisted_12)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}